import { Component, Input, OnChanges } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy } from '@angular/core';
@Component({
  selector: 'app-pie-chart',
  standalone: true,
  imports: [NgChartsModule, CommonModule],
  templateUrl: './pie-chart.component.html',
  styleUrl: './pie-chart.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PieChartComponent implements OnChanges {
  @Input() labels: string[] = [];
  @Input() data: number[] = [];
  @Input() title: string = 'Chart';
  @Input() colors: string[] = [];
  @Input() startIndex: number = 0;
  @Input() ItemsPerPage: number = 0;
  @Input() compact: boolean = false; // when true, uses maintainAspectRatio: false for fixed-height containers

  chartData!: ChartData<'doughnut'>;
  chartOptions!: ChartOptions<'doughnut'>;

  currentPage = 1;

  totalPages = 1;

  ngOnChanges() {
    this.totalPages = Math.ceil(this.labels.length / this.ItemsPerPage);
    this.currentPage = 1;
    this.updateChartData();

    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: true,
      cutout: '80%',
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            color: '#6b7280',
            font: { size: 11 },
            usePointStyle: true,
          },
        },
        tooltip: {
          backgroundColor: '#1f2937',
          bodyColor: '#f9fafb',
          titleColor: '#f9fafb',
          borderWidth: 1,
        },
      },
    };
  }

  updateChartData() {
    const start = (this.currentPage - 1) * this.ItemsPerPage;
    const end = start + this.ItemsPerPage;

    const paginatedLabels = this.labels.slice(start, end);
    const paginatedData = this.data.slice(start, end);

    // Color looping logic
    const paginatedColors = paginatedData.map((_, i) => {
      const colorIndex = (start + i) % this.colors.length;
      return this.colors[colorIndex];
    });

    this.chartData = {
      labels: paginatedLabels,
      datasets: [
        {
          data: paginatedData,
          backgroundColor: paginatedColors,
          hoverOffset: 8,
          borderRadius: 8,
        },
      ],
    };
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updateChartData();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updateChartData();
    }
  }
}
